<template>
    <div v-if="isreadshow">
        <my-search v-model="pgData" @search="searchHandler">
            <el-form-item slot="title">
                <el-input v-model="pgData.txtkey"  placeholder="名称" clearable></el-input>
            </el-form-item>
            <el-form-item slot="time">

            </el-form-item>
            <template slot="btn">
                <el-button type="success" icon="el-icon-plus" @click="edit()">工单申请</el-button>
            </template>
        </my-search>
        <my-table :data="tableData" :height="tableHeight">
            <el-table-column label="主题" prop="title" min-width="220" fixed></el-table-column>
            <el-table-column label="工单编号" prop="gdcode" min-width="220"></el-table-column>
            <el-table-column label="提交时间" width="160" prop="addtime"></el-table-column>
            <el-table-column label="处理状态"  prop="auditstatus"></el-table-column>
            <el-table-column label="处理时间" width="160" prop="audittime"></el-table-column>
            <el-table-column label="处理结果" prop="auditoption"></el-table-column>
            <el-table-column label="操作" width="160" fixed="right">
                <template slot-scope="scope">
                    <div v-if="scope.row.shbj==='0'">
                        <my-btn type="edit" @click="edit(scope.row.id)">编辑</my-btn>
                        <my-btn type="del" @click="del(scope.row.id)">删除</my-btn>
                    </div>
                    <div v-if="scope.row.shbj==='1'">
                        <my-btn type="detail" @click="detail(scope.row.id)">详情</my-btn>
                        <el-button icon="el-icon-close"  v-if="scope.row.auditstatus!=='1'" type="text" @click="tuihui(scope.row.id)">撤回</el-button>
                    </div>
                </template>
            </el-table-column>
        </my-table>
        <my-pagination ref="page" v-model="tableData" :search="pgData" :action="`${getGetters('mngUrl')}/manage/business/xgsq/get_list.json`"></my-pagination>
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
export default {
    mixins: [LIST_PAGE_MIXIN],
    data() {
        return{
            pgData:{
                txtkey:'',
                sortname : 'addtime',
                
            },
            isreadshow:true,
            tableData:[]
        }
    },
    computed: {
        
    },
    watch: {

    },
    methods: {
        //修改
        edit:function(id){
            this.goto({
                path:'./form',
                query:{
                    id:id
                }
            });
        },
        //退回
        tuihui:function(id){
            var that=this;
            ShowConfirm('请确认是否撤回？','warning',()=>{
                that.$get(`${this.getGetters('mngUrl')}/manage/business/xgsq/tuihui.json`,{id:id}, (data, res) => {
                    ShowMsg('撤回成功', 'success')
                    that.reload()
                });
            })
        },
        //删除
        del:function(id){
            var that=this;         
            that.$post(`${this.getGetters('mngUrl')}/manage/business/xgsq/del.json`,{id:id,oper:'del'}, (data, res) => {
                ShowMsg('删除成功', 'success')
                that.reload()
            });          
        },
        //刷新
        reload:function(){
            var that = this;
            this.isreadshow=false;
            this.$nextTick(function(){
                that.isreadshow=true;
            })
        },
        //详情
        detail:function(id){
            this.goto({
                path:'./detail',
                query:{
                    id:id
                }
            });
        }
    },
    created() {
        
    },
    mounted() {
        
    }
}
</script>

<style scoped lang="scss">

</style>
